import {
  getAccount,
  getProfile,
  getUserPremiumStatus,
} from "../../../api/account/requests";
import {getFreeTrialEligibility} from "../../../api/subscription/requests";
import {mergeAll} from "ramda";
import {useToken} from "../token";
import {useQuery} from "@tanstack/react-query";

const useUser = () => {
  const {data: token} = useToken();

  const {data: user} = useQuery({
    queryKey: ["user", token?.account_id],
    queryFn: async () => {
      const [account, profile] = await Promise.all([
        getAccount(),
        getProfile(),
      ]);
      const [freeTrialEligibility, premiumStatus] = await Promise.all([
        getFreeTrialEligibility(account.externalId),
        getUserPremiumStatus(account.externalId),
      ]);
      return mergeAll([account, profile, freeTrialEligibility, premiumStatus]);
    },
    enabled: !!token?.account_id,
    staleTime: Infinity,
  });

  return user;
};

export default useUser;
